import React, { useState, useEffect } from "react";
import { Link } from "gatsby";

import footerMap from "../../assets/images/footer-map.png";
import beian from "../../assets/images/beianlogo.png";

const Footer = () => {
  const [isCN, setIsCN] = useState(false);

  useEffect(() => {
    const path = window.location.host;
    setIsCN(path && path.indexOf("darensoft.cn") !== -1);
  }, []);

  const friendlyLinks = [
    // { name: "AWS", link: "https://aws.amazon.com/cn/" },
    // { name: "阿里云", link: "https://www.aliyun.com/" },
    // { name: "七牛云", link: "https://www.qiniu.com/" },
    { name: "E签宝", link: "https://www.esign.cn" },
    { name: "捕鱼科技", link: "http://www.cv-parser.com/" },
  ];

  const products = [
    { name: "人才招聘", link: "/recruitment" },
    { name: "组织发展", link: "/organization" },
    { name: "员工关系", link: "/employee" },
    { name: "时间管理", link: "/attendance" },
    { name: "培训管理", link: "/training" },
    { name: "薪酬福利", link: "/salary" },
    { name: "绩效考评", link: "/performance" },
    { name: "个人中心", link: "/selfcenter" },
  ];

  return (
    <footer className="footer-area bg-color">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-sm-4">
            <div className="single-footer-widget pl-5">
              <h3>产品</h3>

              <ul className="footer-links-list d-flex flex-wrap">
                {products.map(product => (
                  <li className="col-6 px-0">
                    <Link to={product.link}>{product.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-lg-3 col-sm-4">
            <div className="single-footer-widget">
              <h3>资讯</h3>

              <ul className="footer-links-list">
                <li>
                  <Link to="/superiority">为什么选择我们</Link>
                </li>
                <li>
                  <Link to="/trends/page_1">客户案例</Link>
                </li>
                <li>
                  <Link to="/changelog">产品日志</Link>
                </li>
                <li>
                  <Link to="/industryInfo/all/page_1">行业资讯</Link>
                </li>
                {/* <li><Link to="/news">公司动态</Link></li>  */}
                {/* <li><Link to="/skills">操作技巧</Link></li>   */}
                <li>
                  <Link to="/about">关于大任</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-3 col-sm-4">
            <div className="single-footer-widget">
              <h3>联系我们</h3>

              <ul className="footer-contact-info">
                <li>
                  <i className="bx bx-envelope"></i>
                  <a href="mailto:contact@darensoft.com">contact@darensoft.com</a>
                </li>
                <li>
                  <i className="bx bx-phone-call"></i>
                  <a href="tel:400-028-5267">400-028-5267</a>
                </li>
                <li>
                  <i className="bx bx-map"></i>
                  成都市高新区天府软件园E6-1116
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom-area text-center">
          <div className="row align-items-center">
            <div className="col-lg-12 col-md-6">
              <ul>
                <li className="list-inline-item mr-4">© 2021 成都市大任软件有限责任公司</li>
                <li className="list-inline-item mr-4">
                  <a className="text-foot" href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" rel="nofollow noopener noreferrer">
                    {isCN ? "蜀ICP备09012266号-2" : "蜀ICP备09012266号-1"}
                  </a>
                </li>
                <li className="list-inline-item mr-4">
                  <a className="text-foot" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002001512" target="_blank" rel="nofollow noopener noreferrer">
                    <img src={beian} className="avatar avatar-ex-sm foot-img mr-1" alt="川公网安备" />
                    川公网安备 51019002001512号
                  </a>
                </li>
                <li className="list-inline-item mr-4">
                  <Link to="/terms" rel="nofollow noopener noreferrer">
                    服务条款
                  </Link>
                </li>
                <li className="list-inline-item mr-4">
                  <Link to="/privacy" rel="nofollow noopener noreferrer">
                    隐私政策
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-12 col-md-6 mt-2">
              <span className="mr-2 list-inline-item" style={{ color: "#6b6b84" }}>
                友情链接:
              </span>
              <ul className="d-inline">
                {friendlyLinks.map(flink => (
                  <li>
                    <Link to={flink.link} target="_blank" rel="nofollow noopener noreferrer">
                      {flink.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-map">
        <img src={footerMap} alt="人力资源管理系统" />
      </div>
    </footer>
  );
};

export default Footer;
